import {
  COMPOSER_MAX_HEIGHT_RATIO,
  COMPOSER_MESSAGE_LIST_MIN_HEIGHT,
  COMPOSER_MIN_HEIGHT,
  COMPOSER_THREAD_CHROME_HEIGHT,
} from './constants'

/**
 * The tallest the inbox composer may be: a share of the window height (COMPOSER_MAX_HEIGHT_RATIO), further capped so
 * the message list keeps its minimum inside the thread below the measured title row. Never negative; a `threadHeight`
 * of 0 (not yet measured) adds no cap.
 */
export const getComposerMaxHeight = (windowHeight: number, threadHeight: number, titleHeight: number): number => {
  // The list keeps its minimum once the thread is measured — 0 until then, so no bound yet.
  const listBound = threadHeight
    ? threadHeight - titleHeight - COMPOSER_THREAD_CHROME_HEIGHT - COMPOSER_MESSAGE_LIST_MIN_HEIGHT
    : Infinity
  return Math.max(0, Math.min(Math.round(windowHeight * COMPOSER_MAX_HEIGHT_RATIO), listBound))
}

/**
 * Clamps a composer height between COMPOSER_MIN_HEIGHT and `maxHeight`; ConversationDetail applies it to the stored
 * height at render and to each drag or keyboard resize. A `maxHeight` below COMPOSER_MIN_HEIGHT wins — the list's floor
 * outranks the composer's on a short window.
 */
export const clampComposerHeight = (value: number, maxHeight: number): number =>
  Math.min(maxHeight, Math.max(COMPOSER_MIN_HEIGHT, value))
